import { render, staticRenderFns } from "./CampaignsSingle.vue?vue&type=template&id=76420f7c&"
import script from "./CampaignsSingle.vue?vue&type=script&lang=js&"
export * from "./CampaignsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports